<div id="preloader">
  <div class="wrapper_load">
    <img src="assets/images/loader.gif" alt="">
    <div class="focus">
    </div>
  </div>
</div>
